import React, { useState, useEffect } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import InputText from "../../../components/form/inputText";
import PrimaryButton from "../../../components/buttons";
import Textarea from "../../../components/form/textarea";
import TimePicker from "../../../components/timePicker";
import MuiSelect from "../../../components/muiSelect";
import { actionNotifier } from "../../../components/ui/toast";
import classes from "./styles.module.scss";
import { useGetLanguageQuery } from "../../../store/common/commonApiSlice";
import { addFiveThirty } from "../../../shared/dateFunction";
const modalStyle = {
    position: "absolute",
    top: "7vh",
    right: 0,
    borderRadius: 4,
    p: 0,
    outline: "none",
    backgroundColor: "#fff",
};

const EditAddWebinarModal = ({ open, close, onSave, initialData }) => {
    const defaultState = {
        name: "",
        description: "",
        meetingTime: "",
        length: 60,
        languageId: null,
        type: "",
        recLink: ""
    };

    const [webinarState, setWebinarState] = useState(defaultState);

    useEffect(() => {
        if (initialData) {
            setWebinarState({
                name: initialData.name || "",
                description: initialData.description || "",
                meetingTime: initialData.onDateTime || "",
                length: initialData.meetingTime || 60,
                languageId: initialData.Language?.id || null,
                type: initialData.type || "",
                recLink: initialData.recordingLink || ""
            });
        }
    }, [initialData]);

    const handleClose = () => {
        setWebinarState(defaultState);
    }

    const handleChange = (name, value) => {
        setWebinarState({ ...webinarState, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!webinarState.name || !webinarState.meetingTime) {
            actionNotifier.error("Name and Meeting Time are required");
            return;
        }
        await onSave(webinarState, handleClose);

    };

    const { data: languageOptions } = useGetLanguageQuery({
        "dropdownCode": "LANGUAGES",
        "search": "",
        "key": []
    })

    const webinarTypes = [
        { id: "group_mentoring", label: "Group Mentoring" },
        { id: "doubt_solving", label: "Doubt Solving" },
        { id: "feedback", label: "Feedback" },
    ];

    return (
        <div className={classes.edit_checker_modal}>
            <Modal open={open} onClose={() => { close(); setWebinarState(defaultState) }} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <Box sx={modalStyle}>
                    <div className={classes.edit_webinar_modal_container}>
                        <form onSubmit={handleSubmit}>
                            <div className={classes.edit_webinar_modal_header}>
                                <p>{initialData ? "Edit Webinar" : "Add Webinar"}</p>
                                <PrimaryButton type="submit" buttonText="Save" />
                            </div>

                            <div className={classes.edit_webinar_modal_body}>
                                <InputText
                                    label="Webinar Name"
                                    value={webinarState.name}
                                    onChange={(e) => handleChange("name", e.target.value)}
                                    required
                                />
                                <Textarea
                                    label="Description"
                                    value={webinarState.description}
                                    onChange={(e) => handleChange("description", e.target.value)}
                                    required
                                />
                                <InputText
                                    label="Meeting Date & Time"
                                    type="datetime-local"
                                    value={webinarState?.meetingTime?.slice(0, 16) || ""}
                                    onChange={(e) => handleChange("meetingTime", e.target.value)}
                                    required
                                />
                                <InputText
                                    label="Duration (in minutes)"
                                    type="number"
                                    value={webinarState.length}
                                    onChange={(e) => handleChange("length", Number(e.target.value))}
                                    required
                                />
                                <MuiSelect
                                    label="Language"
                                    value={webinarState.languageId}
                                    options={languageOptions}
                                    onChange={(e) => handleChange("languageId", e.target.value)}
                                    firstValue={true}
                                    firstValueText="Select Language"
                                />
                                <MuiSelect
                                    label="Webinar Type"
                                    value={webinarState.type}
                                    options={webinarTypes}
                                    onChange={(e) => handleChange("type", e.target.value)}
                                    firstValue={true}
                                    firstValueText="Select Type"
                                />
                                <InputText
                                    label="Recording Link (If Any)"
                                    value={webinarState.recLink}
                                    onChange={(e) => handleChange("recLink", e.target.value)}

                                />
                            </div>
                        </form>
                    </div>

                </Box>
            </Modal>
        </div>
    );
};

export default EditAddWebinarModal;
